/**
 * Tiles start one after the other (I-3641). Every frame loads a whole Connect;
 * several at once, as after a reload, can run the browser out of request slots.
 * The queue only spaces them out: a frame that takes long never holds the others
 * back for more than a moment, and what a frame does when it fails is
 * `tileFrame.ts`'s business.
 */
export const TILE_START_SPACING_MS = 6_000;

interface Waiting {
  tileId: string;
  start: () => void;
}

export function createTileStartQueue(spacingMs = TILE_START_SPACING_MS) {
  const waiting: Waiting[] = [];
  let current: string | null = null;
  let timer: ReturnType<typeof setTimeout> | undefined;

  function next(): void {
    clearTimeout(timer);
    current = null;
    const entry = waiting.shift();
    if (!entry) return;
    current = entry.tileId;
    timer = setTimeout(next, spacingMs);
    entry.start();
  }

  return {
    /** `first`: what the user looks at starts before what lies waiting. */
    request(entry: Waiting, first = false): void {
      if (first) waiting.unshift(entry);
      else waiting.push(entry);
      if (!current) next();
    },
    /** The frame had its turn, or its tile went away. */
    done(tileId: string): void {
      const at = waiting.findIndex((entry) => entry.tileId === tileId);
      if (at >= 0) waiting.splice(at, 1);
      if (current === tileId) next();
    },
  };
}

export const tileStartQueue = createTileStartQueue();
